import BalmUI from 'balm-ui';
import BalmUIPlus from 'balm-ui/dist/balm-ui-plus';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(BalmUI, {
    $theme: {
      primary: '#F26522',
      secondary: '#004E7D',
      'on-surface': '#757575',
      'on-primary': '#757575',
      error: '#FD4E4C',
      'on-error': '#FD4E4C',
    },
  });
  nuxtApp.vueApp.use(BalmUIPlus);
});
